// Images
import imgBiberburg from '../assets/images/hausboote/biberburg.jpg';
import imgEisvogel from '../assets/images/hausboote/eisvogel.jpg';
import imgFlussseeschwalbe from '../assets/images/hausboote/flussseeschwalbe.jpg';
import imgWeissstorch from '../assets/images/hausboote/weissstorch.jpg';
import imgHaubentaucher from '../assets/images/hausboote/haubentaucher.jpg';
import imgSeeadler from '../assets/images/hausboote/seeadler.jpg';
import imgKormoran from '../assets/images/hausboote/kormoran.jpg';

export const tours = [
  {
    id: 'biberburg',
    title: 'Biberburg',
    img: imgBiberburg,
    url: 'https://my.matterport.com/show/?m=sRLnaQTgKDC',
  },
  {
    id: 'eisvogel',
    title: 'Eisvogel',
    img: imgEisvogel,
    url: 'https://my.matterport.com/show/?m=R5qfxhmhz83',
  },
  {
    id: 'flussseeschwalbe',
    title: 'Flussseeschwalbe',
    img: imgFlussseeschwalbe,
    url: 'https://my.matterport.com/show/?m=NYHaQL3xZvQ',
  },
  {
    id: 'weissstorch',
    title: 'Weißstorch',
    img: imgWeissstorch,
    url: 'https://my.matterport.com/show/?m=bDAAKo73REC',
  },
  {
    id: 'haubentaucher',
    title: 'Haubentaucher',
    img: imgHaubentaucher,
    url: 'https://my.matterport.com/show/?m=hw9D47Jm46G',
  },
  {
    id: 'seeadler',
    title: 'Seeadler',
    img: imgSeeadler,
    url: 'https://my.matterport.com/show/?m=rWtwjQyQVJb',
  },
  {
    id: 'kormoran',
    title: 'Kormoran',
    img: imgKormoran,
    url: 'https://my.matterport.com/show/?m=AdEgD4wG45z',
  },
];
